import { render, staticRenderFns } from "./ProjectField.vue?vue&type=template&id=7fbf1572&"
import script from "./ProjectField.vue?vue&type=script&lang=js&"
export * from "./ProjectField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fbf1572')) {
      api.createRecord('7fbf1572', component.options)
    } else {
      api.reload('7fbf1572', component.options)
    }
    module.hot.accept("./ProjectField.vue?vue&type=template&id=7fbf1572&", function () {
      api.rerender('7fbf1572', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/components/fields/ProjectField.vue"
export default component.exports